import { STEPS } from "./constants";
import StepLabel from "./StepLabel";
import { isStepComplete, type StepCompletion } from "./types";

export interface StepProgressProps {
  activeStep: number;
  completion: StepCompletion;
  onSelect: (step: number) => void;
}

export default function StepProgress({ activeStep, completion, onSelect }: StepProgressProps) {
  return (
    <div className="sendin-progress" aria-label="Steg">
      {STEPS.map((step, index) => (
        <button
          key={step.label}
          type="button"
          className={index === activeStep ? "is-active" : undefined}
          onClick={() => onSelect(index)}
        >
          <StepLabel
            index={index}
            label={step.label}
            complete={isStepComplete(index, completion, activeStep)}
          />
        </button>
      ))}
    </div>
  );
}
